import api from '../token';

export const AlterInventario = async (produto) => {
  try {
    const response = await api.post('/closeInventario', produto);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};